import * as React from "react";
import { Video } from "../../video/video.mjs";
import { LightboxContext } from "../lightbox-provider/lightbox-provider.mjs";
const LightboxTrigger = (props) => {
  const { open, id, state, isOpen } = React.useContext(LightboxContext);
  const { children } = props;
  const ref = state == null ? void 0 : state.refs.setReference;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
    var _a;
    if (!React.isValidElement(child)) {
      return child;
    }
    if (child.type === Video) {
      return React.cloneElement(child, {
        // it should open Lightbox and play video in there
        playing: false,
        ...state == null ? void 0 : state.getReferenceProps({
          onPlay: () => {
            open();
            if (child.props.onPlay) {
              child.props.onPlay();
            }
          },
          "aria-controls": isOpen ? id : void 0
        }),
        elementRef: ref
      });
    }
    return React.cloneElement(child, {
      ...state == null ? void 0 : state.getReferenceProps({
        onClick: (e) => {
          e.preventDefault();
          open();
        },
        "aria-controls": isOpen ? id : void 0
      }),
      url: (_a = child.props.url) != null ? _a : "#".concat(id),
      ref
    });
  }));
};
export {
  LightboxTrigger
};
